export const renameModalId = state => state.strategyOverviewPage.renameModalId;